import(/* webpackMode: "eager" */ "D:\\tfs\\AZ01\\_work\\27\\s\\app\\[locale]\\error.tsx");
